<template>
  <div>
    <UIExit label="Exit Syllabus Manager Documentation" :exit-url="defaultRedirect" />
    <TitleWrapper
      :filter-option="false"
      title="SYLLABUS_MANAGER"
      tooltip-title="SYLLABUS_MANAGER"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <div class="bg-white">
      <!--  Section -->
      <documentation :document-list="questionList" answer-page="syllabus-question" />
      <!-- Footer -->
    </div>
  </div>
</template>

<script>
import documentation from '@src/router/layouts/app-document/documentation.vue'
import TitleWrapper from '@/src/components/TitleWrapper.vue'
import UIExit from '@/src/components/UiElements/UIExit.vue'
import ROUTE from '@/src/constants/route-constants.js'
import SYLLABUS_MANAGER_DATA from '@/src/router/layouts/app-document/syllabus-automater-documentation/syllabus-manager.json'

export default {
  components: {
    documentation,
    TitleWrapper,
    UIExit,
  },
  page: {
    title: 'syllabus Documentation',
    meta: [{ name: 'syllabus manager documentation', content: 'syllabus manager documentation' }],
  },
  data() {
    return {
      landingPage: 'landingPage',
      defaultRedirect: ROUTE.QUICK_ACTION.PATH,
      questionList: SYLLABUS_MANAGER_DATA.questionList,
    }
  },
}
</script>
